"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("react-slideshow-image/dist/styles.css");
var HomeModel_1 = require("../models/HomeModel");
var CustomZoom_1 = require("./CustomPanel/CustomZoom");
var DeletePics_1 = require("./CustomPanel/DeletePics");
var CustomDropZone_1 = require("./Admin/CustomDropZone");
var NeuesEvent_1 = require("./CustomPanel/NeuesEvent");
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        _this.DeletePics = React.createRef();
        _this.textDialog = React.createRef();
        _this.textConfirm = function (data) {
            if (data !== null) {
                _this.uploadText(data)
                    .then(function () { return _this.setState({ data: data }); });
            }
            _this.textDialog.current.closeDialog();
        };
        _this.deleteTextConfirm = function (data) {
            if (data !== null) {
                _this.deleteEvent()
                    .then(function () {
                    return _this.props.deletedEvent();
                });
            }
            _this.textDialog.current.closeDialog();
        };
        _this.deleteConfirm = function (data) {
            if (data !== null) {
                _this.deleteFiles(data.map(function (x) { return x.path; }));
            }
            _this.DeletePics.current.closeDialog();
        };
        _this.editText = function () {
            _this.textDialog.current.updateData(_this.state.data, _this.props.folderName === "" ? "Home" : _this.state.data.headLine);
        };
        _this.deletePics = function () {
            _this.DeletePics.current.updateData("der Startseite", _this.state.images);
        };
        _this.deleteFiles = function (images) {
            var formdata = new FormData();
            formdata.append("FolderName", _this.props.folderName);
            images.forEach(function (item, i) {
                formdata.append('ImageNames', item);
            });
            fetch('api/Image/Delete', {
                headers: new Headers({
                    'Authorization': 'Basic QW5kaTpBbmRpJ3NCdXJnZXI='
                }),
                method: 'Post',
                body: formdata
            })
                .then(function (response) {
                if (response.ok)
                    _this.getData("Home/GetImages?FolderName=" + _this.props.folderName)
                        .then(function (data) {
                        _this.setState({ images: data });
                    });
            })
                .catch(function (error) { return console.log(error); });
        };
        _this.deleteEvent = function () {
            return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    fetch('api/Events/Delete?FileName=' + this.props.fileName, {
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': 'Basic QW5kaTpBbmRpJ3NCdXJnZXI='
                        }),
                        method: 'get'
                    })
                        .then(function (response) {
                        if (response.status === 200) {
                            resolve();
                        }
                        else {
                            reject();
                        }
                    });
                    return [2 /*return*/];
                });
            }); });
        };
        _this.uploadFiles = function (images) {
            var formdata = new FormData();
            formdata.append("FolderName", _this.props.folderName);
            images.forEach(function (item, i) {
                formdata.append('Files', item, item.name);
            });
            fetch('api/Image/Post', {
                headers: new Headers({
                    'Authorization': 'Basic QW5kaTpBbmRpJ3NCdXJnZXI='
                }),
                method: 'POST',
                body: formdata
            })
                .then(function (response) {
                if (response.ok)
                    _this.getData("Home/GetImages?FolderName=" + _this.props.folderName)
                        .then(function (data) {
                        _this.setState({ images: data });
                    });
            })
                .catch(function (error) { return console.log(error); });
        };
        _this.uploadText = function (data) {
            return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    fetch('api/Home/Post?FileName=' + this.props.fileName, {
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': 'Basic QW5kaTpBbmRpJ3NCdXJnZXI='
                        }),
                        method: 'post',
                        body: JSON.stringify(data)
                    })
                        .then(function (response) {
                        if (response.status === 200) {
                            resolve();
                        }
                        else {
                            reject();
                        }
                    });
                    return [2 /*return*/];
                });
            }); });
        };
        _this.state = { data: new HomeModel_1.default, images: [] };
        _this.getData("Home/Get?FileName=" + _this.props.fileName)
            .then(function (data) {
            _this.setState({ data: data });
        });
        _this.getData("Home/GetImages?FolderName=" + _this.props.folderName)
            .then(function (data) {
            _this.setState({ images: data });
        });
        return _this;
    }
    Slider.prototype.render = function () {
        var _this = this;
        var theme = office_ui_fabric_react_1.Customizations.getSettings(["theme"]).theme;
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Container, null,
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { md: 6, style: { paddingBottom: "15px", paddingTop: "15px" } },
                        this.props.isAdmin &&
                            React.createElement("div", { style: { display: "flex" } },
                                React.createElement("div", { style: { float: "left", fontSize: "20px", fontWeight: 600, color: "rgb(84 82 82 / 94%)" } },
                                    this.state.data.headLine,
                                    React.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Edit' }, title: "Bearbeiten", ariaLabel: "Bearbeiten", onClick: this.editText })),
                                React.createElement("div", { style: { position: "absolute", display: "flex", right: "15px", fontSize: "20px", fontWeight: 600, color: theme.palette.themePrimary } },
                                    React.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Delete' }, title: "Bilder l\u00F6schen", ariaLabel: "Bilder l\u00F6schen", onClick: this.deletePics }))),
                        !this.props.isAdmin &&
                            React.createElement("div", { style: { fontSize: "20px", fontWeight: 600, color: "rgb(84 82 82 / 94%)" } }, this.state.data.headLine),
                        this.state.data.bodyText !== undefined && this.state.data.bodyText.split("\n").length > 1 ?
                            this.state.data.bodyText.split("\n").map(function (text) {
                                return React.createElement("p", { style: { color: "rgba(84, 82, 82, 0.94)" } }, text);
                            }) : React.createElement("p", { style: { color: "rgba(84, 82, 82, 0.94)" } }, this.state.data.bodyText)),
                    React.createElement(reactstrap_1.Col, { md: 6, style: { paddingBottom: "15px", minHeight: "379px" } },
                        React.createElement(CustomZoom_1.CustomZoom, { key: "Zoom", images: this.state.images }),
                        this.props.isAdmin &&
                            React.createElement(CustomDropZone_1.CustomDropZone, { key: "newPics", dropEvent: function (data) { _this.uploadFiles(data); } })))),
            React.createElement(DeletePics_1.default, { key: "StartNewPics", ref: this.DeletePics, deleteEvent: this.deleteConfirm }),
            React.createElement(NeuesEvent_1.default, { key: "EditText", ref: this.textDialog, deleteDataEvent: this.deleteTextConfirm, confirmedEvent: this.textConfirm })));
    };
    Slider.prototype.getData = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                fetch('api/' + url, {
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic QW5kaTpBbmRpJ3NCdXJnZXI='
                    })
                })
                    .then(function (response) { return response.json(); })
                    .then(function (data) { return resolve(data); })
                    .catch(function (error) { return reject(error); });
                return [2 /*return*/];
            });
        }); });
    };
    return Slider;
}(React.Component));
exports.default = Slider;
//# sourceMappingURL=Slider.js.map